import {
  AppStore,
  Facebook,
  GooglePlay,
  Huawei,
  Instagram,
  Linkedin,
  Twitter,
} from '@/components/SvgComponents';
import SvgYouTube from '@/components/SvgComponents/YouTube';
import { Internet } from '@/components/SvgComponents/Internet';
import { NumberSalePrefixIds } from '@/enums/numberSale';

export const isCabinet = ({ currentURL }) =>
  currentURL.includes('cabinet' || 'login');

export const socialNetworks = [
  {
    href: 'https://facebook.com',
    Icon: Facebook,
  },
  {
    href: 'https://facebook.com',
    Icon: Instagram,
  },
  {
    href: 'https://facebook.com',
    Icon: Linkedin,
  },
  {
    href: 'https://facebook.com',
    Icon: Twitter,
  },
  {
    href: 'https://facebook.com',
    Icon: SvgYouTube,
  },
];

export const stores = [
  {
    href: 'https://facebook.com',
    Icon: AppStore,
  },
  {
    href: 'https://facebook.com',
    Icon: GooglePlay,
  },
  {
    href: 'https://facebook.com',
    Icon: Huawei,
  },
];

export const points = [
  {
    address: '2041 Post Avenue, Baku',
  },
  {
    address: '2041 Post Avenue, Baku',
  },
  {
    address: '2041 Post Avenue, Baku',
  },
  {
    address: '2041 Post Avenue, Baku',
  },
  {
    address: '2041 Post Avenue, Baku',
  },
  {
    address: '2041 Post Avenue, Baku',
  },
];

export const customerPrefixes = [
  {
    id: 0,
    name: '055',
  },
  {
    id: 1,
    name: '099',
  },
  {
    id: 2,
    name: '010',
  },
  {
    id: 3,
    name: '050',
  },
  {
    id: 4,
    name: '051',
  },
  {
    id: 5,
    name: '060',
  },
  {
    id: 6,
    name: '070',
  },
  {
    id: 7,
    name: '077',
  },
];

export const serialPrefixes = [
  {
    id: 0,
    name: 'AZE',
  },
  {
    id: 1,
    name: 'AA',
  },
];

export const cabinetTariffDetailIcons = [
  {
    type: 'COUNTRYWIDE',
    icon: '/assets/PhoneNew.png',
  },
  {
    type: 'REGION',
    icon: '/assets/PhoneNew.png',
  },
  {
    type: 'REGION',
    icon: '/assets/tel.png',
  },
  {
    type: 'REGION',
    icon: '/assets/tel.png',
  },
  {
    type: 'VOICE',
    icon: '/assets/PhoneNew.png',
  },
  {
    type: 'INTERNET',
    icon: '/assets/InternetNew.png',
  },
  {
    type: 'BONUS_INTERNET',
    icon: '/assets/BonusInternet.png',
  },
  {
    type: 'BONUS_INTERNET',
    icon: '/assets/bonus-net.png',
  },
  {
    type: 'BONUS_INTERNET',
    icon: '/assets/bonus-net.png',
  },
  {
    type: 'WHATSAPP',
    icon: '/assets/wp.png',
  },
  {
    type: 'TELEGRAM',
    icon: '/assets/telegram.png',
  },
  {
    type: 'ON_NET',
    icon: '/assets/PhoneNew.png',
  },
  {
    type: 'OFF_NET',
    icon: '/assets/PhoneNew.png',
  },
  {
    type: 'SOCIAL_MEDIA',
    icon: '/assets/social.png',
  },
  {
    type: 'ROAMING',
    icon: '/assets/plane.png',
  },
];

export const testDevice = {
  name: 'iPhone 15 Pro Max 512 GB Black',
  images: [
    {
      id: 1,
      url: '/assets/device1.png',
    },
    {
      id: 2,
      url: '/assets/device2.png',
    },
    {
      id: 3,
      url: '/assets/device3.png',
    },
    {
      id: 4,
      url: '/assets/device4.png',
    },
    {
      id: 5,
      url: '/assets/device1.png',
    },
    {
      id: 6,
      url: '/assets/device1.png',
    },
    {
      id: 7,
      url: '/assets/device1.png',
    },
    {
      id: 8,
      url: '/assets/device1.png',
    },
    {
      id: 9,
      url: '/assets/device1.png',
    },
    {
      id: 10,
      url: '/assets/device1.png',
    },
    {
      id: 11,
      url: '/assets/device1.png',
    },
  ],
  inStock: true,
  freeDelivery: true,
  price: 5000.99,
  discountPrice: 4499.99,
  description:
    'Əldə etdiyiniz mobil cihazın IMEI kodunu, SMS ilə 3454 koduna göndərməklə aylıq 2GB internet əldə edə bilərsiniz. IMEI kodu öyrənmək üçün cihazında *#06# düymələrini sıxın.',
  capacities: [
    { id: 1, value: 256, unit: 'GB' },
    { id: 2, value: 128, unit: 'GB' },
    { id: 3, value: 64, unit: 'GB' },
  ],
  colors: [
    { id: 1, value: 'Green', colorCode: '#456735' },
    { id: 2, value: 'Black', colorCode: '#000' },
    { id: 3, value: 'Red', colorCode: '#FF0037' },
    { id: 4, value: 'Yellow', colorCode: '#fddb59' },
  ],
  offerIncludes: [
    {
      id: 1,
      title: 'Internet',
      value: 'Pulsuz 12 aylıq, ayda 2GB',
      icon: <Internet />,
    },
    {
      id: 2,
      title: 'Zəmanət',
      value: '1 illik rəsmi zəmanətlə',
      icon: <Internet />,
    },
    {
      id: 3,
      title: 'Ödəniş üsulları',
      value: 'Nağd və kartla',
      icon: <Internet />,
    },
  ],
  months: [
    { id: 1, value: 3 },
    { id: 2, value: 6 },
    { id: 3, value: 12 },
    { id: 4, value: 18 },
  ],
  characteristics: [
    {
      id: 1,
      title: 'Şəbəkə',
      icon: <Internet />,
      values: [
        { title: 'LTE', value: 'Var' },
        { title: 'NFC', value: 'Var' },
        { title: 'Apple pay', value: 'Var' },
        { title: 'SIM-kart növü', value: 'Nano-SIM / eSIM' },
        { title: 'SIM-kart sayı', value: '1' },
      ],
    },
    {
      id: 2,
      title: 'Prosessor',
      icon: <Internet />,
      values: [
        { title: 'Əməliyyat sistemi', value: 'iOS 17' },
        { title: 'Prosessor tipi (Chipset)', value: 'Apple A17 Pro (3 nm)' },
        { title: 'Prosessor tezliyi (CPU)', value: 'Hexa-core (2x + 4x)' },
        {
          title: 'Qrafik prosessor (GPU)',
          value:
            'Apple GPU (6-core graphics)Apple GPU (6-core graphics)Apple GPU (6-core graphics)Apple GPU (6-core graphics)Apple GPU (6-core graphics)Apple GPU (6-core graphics)Apple GPU (6-core graphics)Apple GPU (6-core graphics)',
        },
        { title: 'Nüvə sayı', value: '6' },
      ],
    },
    {
      id: 2,
      title: 'Prosessor',
      icon: <Internet />,
      values: [
        { title: 'Əməliyyat sistemi', value: 'iOS 17' },
        { title: 'Prosessor tipi (Chipset)', value: 'Apple A17 Pro (3 nm)' },
        { title: 'Prosessor tezliyi (CPU)', value: 'Hexa-core (2x + 4x)' },
        {
          title: 'Qrafik prosessor (GPU)',
          value: 'Apple GPU (6-core graphics)',
        },
        { title: 'Nüvə sayı', value: '6' },
      ],
    },
    {
      id: 2,
      title: 'Prosessor',
      icon: <Internet />,
      values: [
        { title: 'Əməliyyat sistemi', value: 'iOS 17' },
        { title: 'Prosessor tipi (Chipset)', value: 'Apple A17 Pro (3 nm)' },
        { title: 'Prosessor tezliyi (CPU)', value: 'Hexa-core (2x + 4x)' },
        {
          title: 'Qrafik prosessor (GPU)',
          value: 'Apple GPU (6-core graphics)',
        },
        { title: 'Nüvə sayı', value: '6' },
      ],
    },
    {
      id: 2,
      title: 'Prosessor',
      icon: <Internet />,
      values: [
        { title: 'Əməliyyat sistemi', value: 'iOS 17' },
        { title: 'Prosessor tipi (Chipset)', value: 'Apple A17 Pro (3 nm)' },
        { title: 'Prosessor tezliyi (CPU)', value: 'Hexa-core (2x + 4x)' },
        {
          title: 'Qrafik prosessor (GPU)',
          value: 'Apple GPU (6-core graphics)',
        },
        { title: 'Nüvə sayı', value: '6' },
      ],
    },
  ],
};

export const dummyCreditMonthes = [2, 3, 6, 9, 12, 18, 24];

export const dummyPaymentType = [
  {
    id: 0,
    type: 'BirBank',
  },
  {
    id: 1,
    type: 'numbersale:payment.payOnline',
  },
];

export const allowedKeys = [
  'Tab',
  'Enter',
  'ArrowLeft',
  'ArrowRight',
  'Delete',
  'Control',
  'Shift',
  'Alt',
  'Meta',
  'Backspace',
];

export const numberLevels = [
  { name: 'All', value: '' },
  { name: 'Simple', value: 'SIMPLE' },
  { name: 'Bronze', value: 'BRONZE' },
  { name: 'Silver', value: 'SILVER' },
  { name: 'Gold', value: 'GOLD' },
  { name: 'Platinum', value: 'PLATINUM' },
];
export const allValues = ['all', 0, 'All'];

export const defaultTab = { name: 'All', value: '' };

export const freeDeliveryPrice = 100;

export const socialMediaTypes = [
  {
    type: 'WHATSAPP',
    img: '/media/uploads/icons/whatsapp-icon_pAuSlbC.png',
  },
  {
    type: 'TELEGRAM',
    img: '/media/uploads/icons/telegram_icon_mT71pQc.png',
  },
  {
    type: 'INSTAGRAM',
    img: '/media/uploads/icons/instagram.png',
  },
  {
    type: 'FACEBOOK',
    img: '/media/uploads/icons/Facebook_1_1hrgojw.svg',
  },
];

export const numberSalePrefixes = [
  {
    name: 'All',
    id: NumberSalePrefixIds.All,
  },
  {
    name: '055',
    id: NumberSalePrefixIds.Prefix055,
  },
  {
    name: '099',
    id: NumberSalePrefixIds.Prefix099,
  },
];

export const breakPoints = {
  xs: 480,
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1440,
};

export const validCountries = [
  'Azerbaijan',
  'Азербайджан',
  'Azərbaycan',
  'Azerbaycan',
];

export const daysOfWeek = {
  az: ['B', 'B.e', 'Ç.ə', 'Ç', 'C.a', 'C', 'Ş'],
  en: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  ru: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
};
